<template>
  <div class="page-outbox">
  	<!--搜索框-->
  	<div class="search-group-wapper">
  		<search-block @searchSub='searchSub' ref="searchBlock"></search-block>
  	</div>
  	<!--内容区域-->
  	<div class="content-wapper">
  		<!--banner-->
  		<div class="user-banner">
  			<img class="user-avatar" :src="headImgUrl" />
  			<h3 class="user-name">{{this.$store.state.userInfo.user_name}}</h3>
  			<i class="setting-icon" @click="setBasicInfo"></i>
  		</div>
  		<!--我的订单-->
  		<div class="my-order-box">
  			<div class="info-title">我的订单</div>
  			<ul class="my-order-menus">
  				<li class="my-order-menu-item" @click="toOrderList('all')">
  					<img class="my-order-menu-icon" src="../../assets/allorder-icon.png"/>
  					<p>全部订单</p>
  				</li>
  				<!--<li class="my-order-menu-item" @click="toOrderList('topay')">
  					<img class="my-order-menu-icon" src="../../assets/topay-icon.png"/>
  					<p>待付款</p>
  					<i class="order-num">{{orderNum.toPay}}</i>
  				</li>-->
  				<!--<li class="my-order-menu-item" @click="toOrderList('payed')">
  					<img class="my-order-menu-icon" src="../../assets/payed-icon.png"/>
  					<p>已付款</p>
  					<i class="order-num">{{orderNum.payed}}</i>
  				</li>-->
  				<li class="my-order-menu-item" @click="toOrderList('tocheck')">
  					<img class="my-order-menu-icon" src="../../assets/tocheck-icon.png"/>
  					<p>待审核</p>
  					<i class="order-num" v-if="orderNum.toCheck">{{orderNum.toCheck}}</i>
  				</li>
  				<li class="my-order-menu-item" @click="toOrderList('checkedorder')">
  					<img class="my-order-menu-icon" src="../../assets/checkedorder-icon.png"/>
  					<p>已审核</p>
  					<i class="order-num" v-if="orderNum.checked">{{orderNum.checked}}</i>
  				</li>
  				<li class="my-order-menu-item" @click="toOrderList('cancel')">
  					<img class="my-order-menu-icon" src="../../assets/cancel-icon.png"/>
  					<p>已取消</p>
  				</li>
  			</ul>
  		</div>
  		<!--我的信息-->
  		<div class="my-info-box">
  			<div class="info-title">我的信息</div>
  			<!--账户信息-->
  			<div class="account-info">
  				<ul class="account-info-list">
  					<li class="account-list-item" @click="toPrepay">
  						<h3 class="account-info-item-val">￥{{$store.state.subOrderInfo.cus_prepay}}</h3>
  						<p class="account-info-item-name">我的预存款</p>
  					</li>
  					<!--<li class="account-list-item">
  						<h3 class="account-info-item-val">{{accountInfo.cardNum}}张</h3>
  						<p class="account-info-item-name">我的代金券</p>
  					</li>
  					<li class="account-list-item">
  						<h3 class="account-info-item-val">{{accountInfo.grade}}</h3>
  						<p class="account-info-item-name">我的积分</p>
  					</li>-->
  				</ul>
  			</div>
  			<!--菜单列表-->
  			<div class="user-menu-box">
  				<ul class="user-menu-list">
  					<li class="user-menu-list-item" @click="toShopBag">
  						<img class="user-menu-list-icon" src="../../assets/shopbag-icon.png" />
  						<label class="user-menu-list-name">我的购物车</label>
  					</li>
  					<li class="user-menu-list-item" @click="toPackageList">
  						<img class="user-menu-list-icon" src="../../assets/trans-icon.png" />
  						<label class="user-menu-list-name">我的配货单</label>
  					</li>
  					<li class="user-menu-list-item" @click="toAddrList">
  						<img class="user-menu-list-icon" src="../../assets/address-icon.png" />
  						<label class="user-menu-list-name">收货地址管理</label>
  					</li>
  					<li class="user-menu-list-item" @click="toInvoiceAddrList">
  						<img class="user-menu-list-icon" src="../../assets/address-icon.png" />
  						<label class="user-menu-list-name">收票地址管理</label>
  					</li>
  					<li class="user-menu-list-item" @click="toInvoiceList">
  						<img class="user-menu-list-icon" src="../../assets/ticket-icon.png" />
  						<label class="user-menu-list-name">发票管理</label>
  					</li>
  				</ul>
  			</div>
  		</div>
  	</div>
  </div>
</template>

<script>
  import SearchBlock from 'basic/searchBlock/searchBlock'
	export default {
    name: '',
    data () {
      return {
		headImgUrl: 'http://m.rhawn.cn/static/logo-icon.png',
      	keyWord:'',
      	orderNum:{
      		toPay:0,
      		payed:0,
      		toCheck:0,
      		checked:0
      	},
      	accountInfo:{
      		toPayNum:273232.82,
      		cardNum:1,
      		grade:1.23
      	}
      }
    },
    mounted(){
			if(this.$route.meta&&this.$route.meta.pageBelong){
				this.$store.commit('setPageBelong',this.$route.meta.pageBelong)
			}
			if(this.$store.state.userInfo.headImgUrl && this.$store.state.userInfo.headImgUrl != ''){
				this.headImgUrl = this.$store.state.userInfo.headImgUrl;
			}
			this.getPrepayInfo();
		},
    methods:{
      searchSub(keyWord){
      	this.$router.push({path:'/GoodsList/'+keyWord})
      },
      setBasicInfo(){
        this.$router.push({path:'/EditBasicInfo'})
      },
      toPrepay(){
        //跳转至我的预存款
        this.$router.push({path:'/Prepay'})
      },
      toOrderList(type){
      	//跳转至订单列表
      	this.$store.commit('setCurOrderType',type);
      	this.$router.push({path:'/OrderList'})
      },
      toShopBag(){
      	this.$router.push({path:'/ShopBag'})
      },
      toPackageList(){
      	this.$router.push({path:'/PackageList'})
      },
      toAddrList(){
      	this.$router.push({path:'/AddrList'})
      },
      toInvoiceAddrList(){
      	this.$router.push({path:'/InvoiceAddrList'})
      },
      toInvoiceList(){
      	this.$router.push({path:'/InvoiceList'})
      },
      getPrepayInfo(){
        if(!this.$store.state.userInfo.user_id){
          //先登录
          this.$router.push('/Login?backRoute='+this.$route.path);
          return;
        }
        this.$cHttp.post('customers/prepaylog',{
          partner:this.$systemConfig.partner,
          apikey:this.$systemConfig.apikey,
          user_id:this.$store.state.userInfo.user_id,
          page_pernum:10,
          current_page:1
        }).then((res)=>{
          console.log(res)
        if(res.status&&res.status==1){
          this.$store.commit('setSubOrderInfo',{
            cus_prepay:res.data. cus_prepay,
            so_no:'',
            so_id:'',
            so_total:0
          })
        }else{
          //this.$toast('暂无数据')
        }
      }).catch((msg)=>{
          //this.$toast(msg);
      })
      }
    },
    components:{
        SearchBlock
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" type="text/scss" rel="stylesheet/scss" scoped>
.search-group-wapper{
	position: absolute;
	top:0;
	left:0;
	width: 100%;
}
.content-wapper{
  position: absolute;
  width: 100%;
  top:.61rem;;
	left:0;
	bottom:0;
  overflow: scroll;
  .user-banner{
  	position:relative;
  	padding: .2rem 0;
  	text-align: center;
  	background:url(../../assets/user-bg.jpg) no-repeat center;
  	background-size: cover;
  	.user-avatar{
  		padding: .05rem;
  		width: .5rem;
  		height:.5rem;
  		border: .04rem solid #ffb8c2;
  		border-radius: .5rem;
  		background-color: #fff;
  	}
  	.user-name{
  		padding-top: .05rem;
  		font-size: .16rem;
  		color: #fff;
  		font-weight: bold;
  		line-height: .25rem;
      min-height: .25rem;
  	}
  	.setting-icon{
  		position: absolute;
  		width: .2rem;
  		height:.2rem;
  		top: .1rem;
  		right:.1rem;
  		background:url(../../assets/setting-icon.png) no-repeat center;
  		background-size: .16rem .16rem;
  		&:active{
  			opacity: .7;
  		}
  	}
  }
  .my-order-box .info-title,.my-info-box .info-title{
  	padding: .05rem .1rem;
  	font-size: .14rem;
  	line-height: .2rem;
  	color: #666;
  	background-color: $mainColor-light3;
  }
  .my-order-box{
  	.my-order-menus{
  		padding: .15rem .1rem;
  		display: flex;
  		justify-content: space-between;
  		box-sizing: border-box;
  		.my-order-menu-item{
  			flex: 1;
  			position: relative;
  			font-size: .12rem;
  			color: #666;
  			text-align: center;
  			.my-order-menu-icon{
  				width: .3rem;
  				height:.3rem;
  				opacity: .65;
  			}
  			&:active .my-order-menu-icon{
  				opacity: 1;
  			}
  			.order-num{
  				position: absolute;
  				top:-.05rem;
  				right:50%;
  				margin-right:-.25rem;
  				width: .2rem;
  				height:.2rem;
  				font-size:.1rem;
  				line-height: .2rem;
  				text-align: center;
  				color: #fff;
  				border-radius: .2rem;
  				background-color: $mainColor;
  			}
  			>p{
  				padding-top: .05rem;
  			}
  		}
  	}
  }
  .my-info-box{
  	.account-info{
  		padding: .15rem .1rem;
  		border-bottom: .08rem solid #eee;
  		.account-info-list{
  			display: flex;
  			text-align: center;
  			.account-list-item{
  				flex: 1;
  				font-size: .13rem;
  				border-right: 1px solid #ddd;
  				&:last-child{
  					border:none;
  				}
  				.account-info-item-val{
  					padding-bottom: .04rem;
  					font-size:.14rem;
  					color: #000;
  				}
  				.account-info-item-name{
  					color: #666;
  				}
  			}
  		}
  	}
  	.user-menu-box{
  		padding-left: .1rem;
  		padding-bottom: .2rem;
  		.user-menu-list{
  			.user-menu-list-item{
  				align-content: center;
  				padding: .08rem .1rem;
  				padding-left: 0;
  				border-bottom: 1px solid #ddd;
  				background:url(../../assets/nav-btn-next.png) no-repeat 98% center;
  				background-size: .15rem .15rem;
  				&:active{
  					background-color: #eee;
  				}
  				.user-menu-list-icon{
  					display: inline-block;
  					vertical-align: middle;
  					padding: .05rem;
  					width: .2rem;
  					height:.2rem;
  					border-radius: .4rem;
  					background-color: $mainColor-light1;
  				}
  				.user-menu-list-name{
  					display: inline-block;
  					vertical-align: middle;
  					padding-left: .1rem;
  					font-size: .14rem;
  					color: #333;
  				}
  			}
  		}
  	}
  }
}
</style>



// WEBPACK FOOTER //
// src/components/userCenter/userCenter.vue